<template>
  <m-dialog
    ref="dlg"
    @save="save"
    :title="kategori && kategori.cuti_kategori_id ? `Ubah Kategori Ketidakhadiran` : `Tambah Kategori Ketidakhadiran`"
  >
    <v-row row wrap justify="center" align="center">
      <v-col cols="12" sm="10" md="8" lg="8" xl="8" class="mb-5">
        <v-form @submit.prevent data-vv-scope="form" lazy-validation>
          <v-row wrap>
            <v-col cols="12" sm="12" md="12" lg="12" class="py-0">
              <label class="caption mb-2 primary--text">
                Nama Kategori Cuti
                <v-icon small color="primary" style="cursor: pointer" @click="onInfo('nama')">mdi-information</v-icon>
              </label>
              <v-text-field
                autofocus
                dense
                single-line
                outlined
                class="mr-5"
                type="string"
                label="Nama Kategori Ketidakhadiran"
                v-model="kategori.nama"
                hint="Masukkan Nama Kategori Ketidakhadiran, contoh: Cuti Khusus"
                data-vv-name="nama"
                data-vv-as="Label"
                v-validate="'required'"
                :error-messages="errors.collect('form.nama')"
              ></v-text-field>
            </v-col>
            <v-radio-group row v-model="kategori.is_saldo">
              <v-col cols="12" sm="12" md="6" class="py-3 black--text">
                <div class="body-1 mb-2">Pilih Kebijakan Saldo</div>
                <div class="d-flex flex-row">
                  <div>
                    <v-radio :value="1"></v-radio>
                  </div>
                  <div>
                    <label class="black--text body-1"> Menerapkan Saldo</label>
                    <div class="caption grey--text">
                      Saldo cuti bertujuan memberikan batasan jumlah cuti yang bisa digunakan dalam periode tertentu.
                      Sehingga akan dihitung cuti yang didapatkan dan sisa cuti yang tersedia, jika cuti telah diajukan.
                      Misalkan untuk Cuti Tahunan
                    </div>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" sm="12" md="6" class="py-3 black--text">
                <div class="body-1 mb-2 white--text">&infin;</div>
                <div class="d-flex flex-row">
                  <div>
                    <v-radio :value="0"></v-radio>
                  </div>
                  <div>
                    <label class="black--text body-1"> Tidak Menerapkan Saldo</label>
                    <div class="caption grey--text">
                      Tidak Menerapkan saldo cuti. Artinya cuti tersebut bisa diajukan tanpa ada batasan jumlah harinya.
                      Namun tetap dibatasi jumlah ajuan maksimal pada setiap pengajuannya. Misalkan untuk Cuti Menikah
                    </div>
                  </div>
                </div>
              </v-col>
            </v-radio-group>

            <v-col cols="12" sm="12" md="12" lg="12" class="py-0">
              <label class="caption mb-2 primary--text">
                Jumlah Saldo Cuti
                <span v-if="Number(kategori.is_saldo) === 0" class="red--text">
                  (tidak diperlukan karena tidak mengurangi saldo)
                </span>
                <v-icon small color="primary" style="cursor: pointer" @click="onInfo('saldo')">mdi-information</v-icon>
              </label>
              <v-text-field
                autofocus
                dense
                single-line
                outlined
                class="mr-5"
                type="number"
                label="Jumlah Saldo Cuti"
                v-model="kategori.jumlah"
                hint="Masukkan Jumlah Saldo Cuti"
                data-vv-name="jumlah"
                data-vv-as="Saldo Cuti"
                :disabled="Number(kategori.is_saldo) === 0"
                :v-validate="Number(kategori.is_saldo) === 0 ? '' : 'required|numeric|min_value:1'"
                :error-messages="errors.collect('form.jumlah')"
                @keypress="isNumber($event)"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="6" lg="6" class="py-0">
              <label class="caption mb-2 primary--text">
                Minimal Masa Kerja (dalam Bulan)
                <v-icon small color="primary" style="cursor: pointer" @click="onInfo('min')">mdi-information</v-icon>
              </label>
              <v-text-field
                autofocus
                dense
                single-line
                outlined
                class="mr-5"
                type="number"
                label="Minimal Masa Kerja"
                v-model="kategori.masa_kerja"
                hint="Masukkan Jumlah Saldo Cuti"
                data-vv-name="masa_kerja"
                data-vv-as="Saldo Cuti"
                v-validate="'required|numeric'"
                :error-messages="errors.collect('form.masa_kerja')"
                @keypress="isNumber($event)"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="6" lg="6" class="py-0">
              <label class="caption mb-2 primary--text">
                Maksimal Ajuan Cuti
                <v-icon small color="primary" style="cursor: pointer" @click="onInfo('max')">mdi-information</v-icon>
              </label>
              <v-text-field
                autofocus
                dense
                single-line
                outlined
                class="mr-5"
                type="number"
                label="Jumlah Maksimal Ajuan Cuti"
                v-model="kategori.maks_ajuan"
                hint="Masukkan Jumlah Maksimal Ajuan Cuti"
                data-vv-name="maks_ajuan"
                data-vv-as="Maksimal Ajuan"
                v-validate="'required|numeric|min_value:1'"
                :error-messages="errors.collect('form.maks_ajuan')"
                @keypress="isNumber($event)"
              >
                <template v-slot:append> Hari </template>
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="6" lg="6" class="py-0">
              <label class="caption mb-2 primary--text">
                Masa Berlaku Cuti
                <v-icon small color="primary" style="cursor: pointer" @click="onInfo('masa')">mdi-information</v-icon>
              </label>
              <v-select
                v-model="kategori.is_berlaku"
                dense
                outlined
                :items="[
                  { value: 0, text: 'Selamanya' },
                  { value: 1, text: 'Sebagian' },
                ]"
              />
            </v-col>
            <template v-if="Number(kategori.is_berlaku) === 1">
              <v-col cols="12" sm="12" md="3" lg="3" class="py-0">
                <label class="caption mb-2 primary--text">Tgl Mulai</label>
                <m-datepicker
                  dense
                  single-line
                  outlined
                  label="Tgl Awal"
                  v-model="kategori.tgl_mulai"
                  hint="Tanggal Awal"
                  :max="kategori.tgl_akhir"
                  data-vv-name="tanggalAwal"
                  data-vv-as="Tanggal Mulai"
                  v-validate="'required'"
                  :error-messages="errors.collect('form.tanggalAwal')"
                ></m-datepicker>
              </v-col>
              <v-col cols="12" sm="12" md="3" lg="3" class="py-0">
                <label class="caption mb-2 primary--text">Tgl Selesai</label>
                <m-datepicker
                  dense
                  single-line
                  outlined
                  label="Tgl Selesai"
                  v-model="kategori.tgl_selesai"
                  :min="kategori.tgl_mulai"
                  hint="Tanggal Akhir"
                  data-vv-name="tanggalAkhir"
                  data-vv-as="Tanggal Selesai"
                  v-validate="'required'"
                  :error-messages="errors.collect('form.tanggalAkhir')"
                ></m-datepicker>
              </v-col>
            </template>
            <v-col cols="12" md="12" sm="12">
              <v-card class="pa-5">
                <v-card-text>
                  <div class="black--text body-1"> <v-icon left>mdi-bell-outline</v-icon> <b>Kebijakan Cuti</b> </div>
                  <v-row class="mt-3">
                    <v-col cols="12" sm="12" md="12" class="py-0">
                      <div class="d-flex flex-row">
                        <div>
                          <v-switch
                            v-model="kategori.is_cuti_tahunan"
                            :true-value="1"
                            :false-value="0"
                            inset
                          ></v-switch>
                        </div>
                        <div class="mt-5">
                          <label class="black--text body-1"> Menerapkan Sebagai Cuti Tahunan ?</label>
                          <div class="caption grey--text">
                            Kategori cuti yang akan ditampilkan di awal pengajuan cuti
                          </div>
                        </div>
                      </div>
                    </v-col>
                    <v-col cols="12" sm="12" md="12" class="py-0">
                      <div class="d-flex flex-row">
                        <div>
                          <v-switch
                            v-model="kategori.is_saldo_cuti_bersama"
                            :true-value="1"
                            :false-value="0"
                            inset
                          ></v-switch>
                        </div>
                        <div class="mt-5">
                          <label class="black--text body-1"> Pengurangan Saldo oleh Cuti Bersama ?</label>
                          <div class="caption grey--text">
                            Saldo otomatis dikurangi sesuai <a @click="toHariLibur">Hari Libur</a> Cuti Bersama. Jika
                            ingin mengaktifkan konfigurasi ini, pastikan telah membuat Hari Libur terlebih dahulu
                          </div>
                        </div>
                      </div>
                    </v-col>
                    <v-col cols="12" sm="12" md="12" class="py-0">
                      <div class="d-flex flex-row">
                        <div>
                          <v-switch v-model="kategori.is_prorata" :true-value="1" :false-value="0" inset></v-switch>
                        </div>
                        <div class="mt-5">
                          <label class="black--text body-1"> Menerapkan Perhitungan Prorata ? </label>
                          <div class="caption grey--text">
                            Akhir masa cuti di sama ratakan pada bulan terakhir pada satu tahun
                          </div>
                        </div>
                      </div>
                    </v-col>
                    <v-col cols="12" sm="12" md="12" class="py-0">
                      <div class="d-flex flex-row">
                        <div>
                          <v-switch v-model="kategori.is_setuju" :true-value="1" :false-value="0" inset></v-switch>
                        </div>
                        <div class="mt-5">
                          <label class="black--text body-1"> Menerapkan Persetujuan Berjenjang ? </label>
                          <div class="caption grey--text">
                            Cuti harus melewati Persetujuan Atasan langsung masing-masing divisi
                          </div>
                        </div>
                      </div>
                    </v-col>
                    <v-col cols="12" sm="12" md="12" class="py-0">
                      <div class="d-flex flex-row">
                        <div>
                          <v-switch v-model="kategori.is_lampiran" :true-value="1" :false-value="0" inset></v-switch>
                        </div>
                        <div class="mt-5">
                          <label class="black--text body-1"> Mewajibkan Unggah Lampiran ?</label>
                          <div class="caption grey--text">
                            Pengguna wajib melampirkan dokumen relevan untuk alasan cuti
                          </div>
                        </div>
                      </div>
                    </v-col>
                    <v-col cols="12" sm="12" md="12" class="py-0">
                      <div class="d-flex flex-row">
                        <div>
                          <v-switch
                            v-model="kategori.is_sisa_cuti"
                            :true-value="true"
                            :false-value="false"
                            inset
                          ></v-switch>
                        </div>
                        <div class="mt-5">
                          <label class="black--text body-1"> Menerapkan Sisa Cuti ?</label>
                          <div class="caption grey--text">
                            Sisa cuti dapat di akumulasi dan digunakan pada tahun berikutnya
                          </div>
                          <div v-if="kategori.is_sisa_cuti">
                            <label class="caption mb-2 primary--text"> Berapa Maksimal Sisa Cuti ? </label>
                            <v-text-field
                              autofocus
                              dense
                              single-line
                              outlined
                              class="mr-5"
                              type="number"
                              label="Minimal Masa Kerja"
                              v-model="kategori.maks_sisa_cuti"
                              hint="Maksimal Sisa Cuti"
                              data-vv-name="maks_sisa_cuti"
                              data-vv-as="Saldo Sisa Cuti"
                              v-validate="'required'"
                              :error-messages="errors.collect('form.maks_sisa_cuti')"
                            ></v-text-field>
                          </div>
                        </div>
                      </div>
                    </v-col>
                    <v-col cols="12" sm="12" md="12" class="py-0">
                      <div class="d-flex flex-row">
                        <div>
                          <v-switch
                            v-model="kategori.is_hutang_cuti"
                            :true-value="true"
                            :false-value="false"
                            inset
                          ></v-switch>
                        </div>
                        <div class="mt-5">
                          <label class="black--text body-1"> Menerapkan Hutang Cuti ?</label>
                          <div class="caption grey--text">
                            Cuti di bebankan pada saldo tahun berikutnya jika melewati jumlah saldo yang di tentukan
                          </div>
                          <div v-if="kategori.is_hutang_cuti">
                            <label class="caption mb-2 primary--text"> Berapa Maksimal Hari Hutang Cuti ? </label>
                            <v-text-field
                              autofocus
                              dense
                              single-line
                              outlined
                              class="mr-5"
                              type="number"
                              label="Maksimal Hari Hutang Cuti"
                              v-model="kategori.maks_hutang_cuti"
                              hint="Maksimal Hari Hutang Cuti"
                              data-vv-name="maks_sisa_cuti"
                              data-vv-as="Maksimal Hari Hutang Cuti"
                              v-validate="'required'"
                              :error-messages="errors.collect('form.maks_sisa_cuti')"
                            ></v-text-field>
                          </div>
                        </div>
                      </div>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-form>
      </v-col>
    </v-row>
    <v-dialog v-model="dialog" width="700" close>
      <v-toolbar dark color="primary">
        <v-toolbar-title class="white--text">Informasi</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon dark @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card>
        <v-card-text class="black--text pa-5">
          <div v-html="info || ''" />
        </v-card-text>
      </v-card>
    </v-dialog>
  </m-dialog>
</template>

<script>
import { toYMD } from '@/tools'
export default {
  $_veeValidate: {
    validator: 'new',
  },

  data() {
    return {
      kategori: {
        is_saldo: 1,
      },
      dialog: false,
      info: null,
    }
  },
  mounted() {},
  methods: {
    // eslint-disable-next-line
    open(obj = {}) {
      this.$validator.reset()
      this.reset()
      this.kategori = obj ? JSON.parse(JSON.stringify(obj)) : {}

      if (Object.keys(obj).length) {
        if (this.kategori.tgl_mulai && this.kategori.tgl_selesai) {
          this.kategori.tgl_mulai = toYMD(this.kategori.tgl_mulai)
          this.kategori.tgl_selesai = toYMD(this.kategori.tgl_selesai)
          this.$set(this.kategori, 'is_berlaku', 1)
        } else {
          this.$set(this.kategori, 'is_berlaku', 0)
        }

        if (this.kategori.maks_sisa_cuti) {
          this.$set(this.kategori, 'is_sisa_cuti', true)
        }

        if (this.kategori.maks_hutang_cuti) {
          this.$set(this.kategori, 'is_hutang_cuti', true)
        }
      }

      return this.$refs.dlg.open()
    },
    reset() {
      this.kategori = {}
    },
    save() {
      this.$validator
        .validateAll('form')
        .then((res) => {
          if (!res) return Promise.reject()
          return res
        })
        .then(() => {
          let kategori = {}
          const keys = [
            'is_cuti_tahunan',
            'is_saldo_cuti_bersama',
            'is_prorata',
            'nama',
            'jumlah',
            'saldo_cuti',
            'is_lampiran',
            'is_setuju',
            'masa_kerja',
            'tgl_mulai',
            'tgl_selesai',
            'maks_sisa_cuti',
            'maks_hutang_cuti',
            'cuti_kategori_id',
            'is_saldo',
            'maks_ajuan',
          ]

          keys.forEach((key) => {
            this.$set(kategori, key, this.kategori[key] || null)
          })

          if (!kategori.cuti_kategori_id) {
            this.$delete(kategori, 'cuti_kategori_id')
          }

          if (Number(kategori.is_saldo) !== 1) {
            this.$set(this.kategori, 'saldo_cuti', 0)
          }

          // if (Number(kategori.maks_ajuan) > Number(kategori.jumlah)) {
          //   this.$error(`Jumlah hari libur instansi Anda [XX] Hari. Pastikan jumlah ajuan cuti dalam hari tidak melebihi hari libur`)
          //   return
          // }

          return this.$store.dispatch('kategori/form', {
            obj: Object.assign({}, { kode_organisasi: this.organisasi_id || '' }, kategori),
            organisasi_id: this.organisasi_id,
          })
        })
        .then((res) => {
          if (res.data.code == 200) {
            this.$info('Simpan Data Berhasil')
            this.$refs.dlg.resolve()
            return res
          }
        })
        .catch((e) => e)
    },

    toHariLibur() {
      this.$router.push({ name: 'hariLibur' })
    },

    isNumber(evt) {
      evt = evt ? evt : window.event
      var charCode = evt.which ? evt.which : evt.keyCode
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
        evt.preventDefault()
      } else {
        return true
      }
    },
    onInfo(key) {
      const objInfo = {
        nama: '<b>Nama Kategori Cuti</b> adalah label yang membedakan antar kategori cuti satu dengan kategori cuti lainnya. Nama kategori cuti juga untuk menandakan sebagai penyebutan suatu cuti. Misal Cuti Sakit, Cuti Tahunan, dll',
        saldo:
          '<b>Jumlah Saldo Cuti</b> adalah jumlah total hari pada kategori yang dibuat dalam suatu kurun waktu tertentu. Misal Cuti Tahunan. Dimana jumlah saldo cuti adalah 12 Hari.',
        min: '<b>Minimal Masa Kerja (dalam bulan)</b> adalah Cuti ini akan diterapkan pada pegawai yang berada pada masa kerja berapa lama. Misalkan jika ingin diterapkan pada pegawai yang sudah 1 tahun. Maka inputkan 12. Jika tidak dibatasi masa kerja. Maka inputkan 0',
        max: '<b>Maksimal Ajuan Cuti</b> adalah batasan kategori cuti ini, dapat diambil dalam sekali pengajuan cuti, itu berapa hari. Apakah bisa langsung ambil cuti sebanyak jumlah saldo. Atau dibatasi. Misal, Cuti Tahunan saldo cutinya adalah 12. Apakah diperbolehkan, pegawai dalam sekali pengajuan cuti tahunan. Langsung diambil 12 hari',
        masa: '<b>Masa Berlaku Cuti</b> adalah untuk penggunaan kategori cuti yang dibuat ini, apakah hanya akan diterapkan/digunakan pada waktu tertentu saja. Ataukah terus berlaku tidak ada batasan waktunya',
      }

      this.info = objInfo[key]
      this.dialog = true
    },
  },
  watch: {
    'kategori.is_hutang_cuti'(n) {
      if (n == 0) {
        this.kategori.maks_hutang_cuti = null
      }
    },
    'kategori.is_sisa_cuti'(m) {
      if (m == 0) {
        this.kategori.maks_sisa_cuti = null
      }
    },
    'kategori.is_akumulasi'(o) {
      if (o == 0) {
        this.kategori.max_sisa_cuti_diambil = 0
      }
    },
    'kategori.is_berlaku'(o) {
      if (o == 0) {
        this.kategori.tgl_mulai = null
        this.kategori.tgl_selesai = null
      }
    },
  },
}
</script>
